import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const StateList = ({ states, loading, error, onSelect, onRetry }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {Array.from({ length: 9 }).map((_, i) => (
          <div
            key={i}
            className="h-20 rounded-lg border border-border bg-muted animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-lg border border-error/30 bg-error/5 p-6 text-center">
        <p className="text-sm font-medium text-error mb-3">{error}</p>
        {onRetry && (
          <Button variant="default" size="sm" onClick={onRetry} iconName="RefreshCw" iconPosition="left">
            Retry
          </Button>
        )}
      </div>
    );
  }

  if (!states?.length) {
    return (
      <div className="rounded-lg border border-border bg-card p-10 text-center shadow-sm">
        <Icon name="Building2" size={32} className="mx-auto mb-2 text-muted-foreground" />
        <p className="text-sm text-muted-foreground">No factories found.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
      {states.map((s) => (
        <button
          key={s.state}
          type="button"
          onClick={() => onSelect(s.state)}
          className="text-left rounded-lg border border-border bg-card p-4 shadow-sm transition-colors hover:border-primary hover:bg-muted/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <p className="font-semibold text-sm sm:text-base text-foreground truncate">
                {s.state}
              </p>
              <p className="text-xs mt-1 text-muted-foreground">
                {s.factoryCount} {s.factoryCount === 1 ? 'factory' : 'factories'}
              </p>
            </div>
            <Icon name="ChevronRight" size={18} className="text-muted-foreground shrink-0 mt-0.5" />
          </div>
        </button>
      ))}
    </div>
  );
};

export default StateList;
